import React from 'react';
import styled from 'styled-components/macro';

// style
import { sanitizePhoneForTel } from '../utils/helpers';
import { useGTMAnalytics } from 'hooks/GTM/useGTMAnalytics';
import { CTAInteractionType } from 'hooks/GTM/actions/CTA/interaction';
import { useTranslation } from 'react-i18next';

type Props = {
  advisorDetails: any;
  isSales?: boolean;
};
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px;
  background: #ffffff;
  box-shadow: 0px 4px 16px rgba(29, 30, 36, 0.06);
  border-radius: 7px;
  box-sizing: border-box;
  width: 384px;
  margin: 0 auto;
  @media screen and (max-width: 520px) {
    border-radius: 0px;
    box-shadow: none;
    width: 100%;
    padding: 20px;
  }
`;

type RowProps = {
  margin?: string;
};

const Row = styled.div<RowProps>`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  margin: ${props => (props.margin ? props.margin : 0)};
`;

type LabelProps = {
  fontSize?: string;
};

const Label = styled.div<LabelProps>`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.black[60]};
  width: fit-content;
`;

const Text = styled.a`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.black[100]};
  text-decoration: none;
  cursor: pointer;
`;

const AdvisorInfo = styled.div`
  margin-bottom: 24px;
`;

const AdvisorName = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.black[100]};
`;

const Small = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: rgba(0, 27, 83, 0.6);
  margin-bottom: 4px;
`;

export const ServiceAdvisorDetails = ({
  advisorDetails,
  isSales = false,
}: Props) => {
  const { trackGTMCTAInteractionEvent } = useGTMAnalytics();
  const { t } = useTranslation();
  const phone =
    advisorDetails?.phone || advisorDetails?.phone1 || advisorDetails?.phone2;
  return (
    <Container className='font-roboto'>
      <AdvisorInfo>
        <Small>
          {t('personalRepresentative', {
            context: isSales ? 'sales' : 'service',
          })}
        </Small>
        <AdvisorName>{`${
          advisorDetails.firstName || ''
        } ${advisorDetails.lastName || ''}`}</AdvisorName>
      </AdvisorInfo>
      {!!phone && (
        <Row margin='0 0 4px'>
          <Label>{t('Phone')}:&nbsp;</Label>
          <Text href={`tel:${sanitizePhoneForTel(phone)}`}>{phone}</Text>
        </Row>
      )}

      {!!advisorDetails?.email && (
        <Row>
          <Label>{t('Email')}:&nbsp;</Label>
          <Text
            href={`mailto:${advisorDetails?.email}`}
            onClick={() =>
              trackGTMCTAInteractionEvent?.({
                type: CTAInteractionType.EMAIL_CLICK,
              })
            }
          >
            {advisorDetails?.email}
          </Text>
        </Row>
      )}
    </Container>
  );
};
